import { Count } from 'mk2/components/NotificationsBadge';
import { schema } from 'normalizr';

/**
 * TODO: It would be great if all entites has
 * createdAt, updatedAt and syncedAt Dates
 * so that we can make queries that will fetch all changed data
 * and also we can detect conflicts
 */
export interface Entity {
    readonly id: number;
}

export interface EntityWithSlug extends Entity {
    slug: string;
}

export enum Plan {
    FREE = 'free',
    PLUS = 'plus',
    PRO = 'pro',
}

export enum Role {
    USER,
    MODERATOR,
    ADMIN,
}

export interface UserEntity extends Entity {
    username: string;
    activePlan: Plan;
    avatar: string;
    avatarCampaign: string;
    phoneVerified: boolean;
    gender: string;
    isBlocked: boolean;
    likesCount: number;
    likers: UserEntity[];
    isUntrustworthy: boolean;
}

export interface PhotoEntity extends Entity {
    // rovnaka hodnota ako PhotoFile.code
    readonly code: string;
    readonly width: number;
    readonly height: number;
    readonly aspect: PhotoAspect;
    readonly mimetype: PhotoMimetype;
    readonly versions: string[];
}

export interface PhotoPreviewEntity extends Entity {
    readonly fileName: string;
    readonly imgBase64Data: string;
    readonly originalWidth: number;
    readonly originalHeight: number;
    readonly aspect: PhotoAspect;
    readonly mimetype: PhotoMimetype;
}

export enum PhotoAspect {
    PORTRAIT = 0,
    LANDSCAPE,
    SQUARE,
}

export enum PhotoMimetype {
    JPEG = 'image/jpeg',
    PNG = 'image/png',
    GIF = 'image/gif',
}

export enum PhotoOrientation {
    NORMAL = 0,
    ROTATED_90,
    ROTATED_180,
    ROTATED_270,
}

export interface OldPhotoUploadResponse {
    token: string;
    photo_code: string;
    photo_versions: {
        [version: string]: {
            url: string;
            height: number;
            width: number;
        };
    };
    photo: PhotoEntity;
}

export const UserSchema = new schema.Entity('user');
export const PhotoSchema = new schema.Entity('photo');
export const PhotoPreviewSchema = new schema.Entity('photoPreview');

export interface SubscribedCounsellingsCounts {
    [topicId: number]: Count;
}

export interface PageHeaderUserData {
    commentsCount: number;
    heartsCount: number;
    unreadMails: number;
    newBazaarEvents: number;
    newBazaarSell: number;
    allBazaarSell: number;
    wallStatusNews: number;
    wishlistUpdates: number;
    groupsCount: number;
    subscribedCounsellings: SubscribedCounsellingsCounts;
}

export enum HeaderMenuItem {
    UserPhoneVerification = 'phone-verification',
    UserSettings = 'settings',
    UserLogin = 'login',
    UserSignup = 'signup',
    BoOrders = 'orders',
    BoTestings = 'testings',
    BazaarSellerSearch = 'heading-sellers',
    BazaarWishlist = 'wishlist',
    BazaarShopping = 'shopping',
    BazaarMyBazaar = 'bazaar',
    BazaarFaq = 'faq',
    BazaarAddItem = 'add-item',
    AdminclubQuestionOfTheDay = 'adminclub-question-of-the-day',
    AdminclubBazaarUser = 'adminclub-bazaar-user',
    AdminclubBazaarSinners = 'adminclub-bazaar-sinners',
    AdminclubBazaarBuyers = 'adminclub-bazaar-buyers',
    AdminclubBazaarCategory = 'adminclub-bazaar-category',
    AdminclubBazaarModerators = 'adminclub-bazaar-moderators',
    AdminclubBazaarModeratorsLife = 'adminclub-bazaar-moderators-life',
    AdminclubBazaarBulkEdit = 'adminclub-bazaar-bulk-edit',
    AdminclubConceptsHierarchy = 'concepts-hierarchy',
    AdminclubForumTopics = 'adminclub-forum-topics',
    AdminclubForumThreads = 'adminclub-forum-threads',
    AdminclubTaggingBlogArticles = 'adminclub-tagging-blogarticles',
    AdminclubTaggingGroups = 'adminclub-tagging-groups',
}

export interface MenuSelection {
    activeSection?: string;
    activeItem?: string;
}

export interface ConceptEntity extends Entity {
    readonly articleId: number;
    readonly path: number[];
}

export const ConceptSchema = new schema.Entity('concepts', {
});

export interface ConceptWithArticleDetailsEntity extends Entity {
    title: string;
    categorySlug: string;
    articleSlug: string;
}

export const ConceptWithArticleDetailsSchema = new schema.Entity('conceptDetails', {});
